import React from 'react';

import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

const buttonStyle = {
    width: 100,
    marginRight: 10,
    marginLeft: 20,
};

const containerStyle = {
    // Todo: what looks best here?
    //overflow: 'visible' // This property forces the text to always scroll to bottom.
}


class ConfirmDialog extends React.Component {

    // Toggle dialog is not provided for all dialogs, as we force the user to click ok or next in some cases.
    // We must therefore check if it exists.
    handleClose = () => {
        if (this.props.toggleDialog != null) {
            this.props.toggleDialog();
        } else {
            e => this.props.onButtonClicked(e);
        }
    };


    render() {
        const { fullScreen } = this.props;
        return (

            /*
            Note that a fix for validateDOMNesting has been done here:

            If this error occurs while using Material UI <Typography> https://material-ui.com/api/typography/,
            then you can easily change the <p> to a <span> by changing the value of the component attribute of the <Typography> element :
            <Typography component={'span'} variant={'body2'}>

            https://stackoverflow.com/questions/41928567/div-cannot-appear-as-a-descendant-of-p
            */
            <Dialog
                fullScreen={fullScreen}
                open={this.props.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.props.titleText}
                </DialogTitle>

                <DialogContent style={containerStyle}>
                    <DialogContentText component={'span'} id="alert-dialog-description">
                        {this.props.messageText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div style={buttonContainerStyle}>
                        <Button
                            autoFocus
                            style={buttonStyle}
                            variant="contained"
                            color="primary"
                            onClick={e => this.props.onButtonClicked(e)}>
                            {this.props.buttonText}
                        </Button >
                    </div>
                </DialogActions>
            </Dialog>
        );


    }
}

ConfirmDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};


export default withMobileDialog()(ConfirmDialog);


// WEBPACK FOOTER //
// ./src/Components/ConfirmDialog.js